import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-help-regulares',
  templateUrl: './help-regulares.component.html',
  styleUrls: ['./help-regulares.component.css']
})
export class HelpRegularesComponent implements OnInit {
  items: MenuItem[] = [];
  constructor(public config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    this.items = this.config.data.items;
  }

}
